export enum LessonStatusCode {
  New = 'New',
  OnModeration = 'OnModeration',
  Approved = 'Approved',
  Declined = 'Declined',
  Published = 'Published',
  Archived = 'Archived',
  Deleted = 'Deleted'
}
